// @core/api/endpoints/activity/acknowledge_all.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AcknowledgeAllRequest,
  AcknowledgeAllResponse,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * Acknowledge all matching activities
 * Bulk acknowledges all activities matching the provided filters. Used for the 'Done' button in Inbox UI.
 */
export async function AcknowledgeAll(
  data: AcknowledgeAllRequest,
  options?: RequestOptions
): Promise<AcknowledgeAllResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/inbox/acknowledge-all`;
  const requestOptions = options;
  return client.post<AcknowledgeAllResponse>(requestPath, data, requestOptions);
}
